import React, { Component } from 'react'
import ReactECharts from 'echarts-for-react'

class GraficoGauge extends Component {
    state = {
        params: {
            descricao: "",
            value: 0,
            unidade: "",
            params: false,
            update: false,
        },
    }

    componentWillMount = () => {
        if (this.props.dataWidget)
            this.setState({ params: this.props.dataWidget })
    }


    componentWillReceiveProps = (nextProps) => {
        if (this.props.dataWidget.value !== nextProps.dataWidget.value)
            this.setState({ params: nextProps.dataWidget })
    }

    getFaixasNormalizadas = (params) => {
        const defs = [
            { key: 'valor_normal', color: '#52c41a' },
            { key: 'valor_alerta', color: '#faad14' },
            { key: 'valor_perigo', color: '#f5222d' },
        ]
        const inverter = params?.tipo_gauge === 'absoluto' && !!params?.inverter

        return defs
            .map(({ key, color }) => {
                const cfg = params?.[key]
                let min = parseFloat(cfg?.min)
                let max = parseFloat(cfg?.max)
                if (isNaN(min) || isNaN(max)) return null
                if (inverter) {
                    const tmp = min
                    min = max
                    max = tmp
                }
                if (max <= min) return null
                return { key, color, min, max }
            })
            .filter(Boolean)
    }

    getSegmentosComFracoes = (params) => {
        const faixas = this.getFaixasNormalizadas(params).sort((a, b) => a.min - b.min)
        if (faixas.length === 0) return []

        const escalaMin = faixas[0].min
        const escalaMax = faixas[faixas.length - 1].max
        const escala = escalaMax - escalaMin || 1

        let cursor = 0
        return faixas.map((f, i) => {
            const fim = i < faixas.length - 1
                ? (faixas[i + 1].min - escalaMin) / escala
                : 1
            const seg = { key: f.key, color: f.color, inicio: cursor, fim }
            cursor = fim
            return seg
        })
    }

    buildColormap = (params) => {
        const segmentos = this.getSegmentosComFracoes(params)
        if (segmentos.length === 0) return [[1, '#d9d9d9']]
        return segmentos.map((s) => [s.fim, s.color])
    }

    deriveMin = (params) => {
        const faixas = this.getFaixasNormalizadas(params)
        return faixas.length > 0 ? Math.min(...faixas.map((f) => f.min)) : 0
    }

    deriveMax = (params, fallback = 100) => {
        const faixas = this.getFaixasNormalizadas(params)
        return faixas.length > 0 ? Math.max(...faixas.map((f) => f.max)) : fallback
    }

    getCorFaixa = (value, params) => {
        const faixas = this.getFaixasNormalizadas(params)
        for (const { min, max, color } of faixas) {
            if (value >= min && value <= max) return color
        }
        return '#1890ff'
    }

    getCorTexto = (value, params) => {
        const cor = this.getCorFaixa(value, params)
        return cor === '#1890ff' ? '#262626' : cor
    }

    buildGaugeOption = (val, valorMin, valorMax, corPonteiro, params) => {
        const colormap = this.buildColormap(params)
        const escala = (valorMax - valorMin) || 1
        const valNorm = Math.min(Math.max((val - valorMin) / escala, 0), 1)

        return {
            series: [
                {
                    type: 'gauge',
                    startAngle: 210,
                    endAngle: -30,
                    min: 0,
                    max: 1,
                    radius: '88%',
                    center: ['50%', '55%'],
                    pointer: { show: false },
                    progress: { show: false },
                    axisLine: {
                        roundCap: true,
                        lineStyle: { width: 16, color: colormap },
                    },
                    axisTick:  { show: false },
                    splitLine: { show: false },
                    axisLabel: { show: false },
                    detail:    { show: false },
                    title:     { show: false },
                    silent: true,
                    data: [{ value: 0 }],
                },
                {
                    type: 'gauge',
                    startAngle: 210,
                    endAngle: -30,
                    min: 0,
                    max: 1,
                    radius: '68%',
                    center: ['50%', '55%'],
                    pointer: { show: false },
                    progress: {
                        show: true,
                        width: 16,
                        roundCap: true,
                        itemStyle: { color: corPonteiro },
                    },
                    axisLine: {
                        roundCap: true,
                        lineStyle: { width: 16, color: [[1, 'rgba(0,0,0,0.04)']] },
                    },
                    axisTick:  { show: false },
                    splitLine: { show: false },
                    axisLabel: { show: false },
                    detail:    { show: false },
                    title:     { show: false },
                    silent: true,
                    data: [{ value: valNorm }],
                },
            ],
        }
    }

    getOptionPercentual = (value, params) => {
        const valorMax = parseFloat(params?.valor_maximo) || 100
        const pct = valorMax > 0 ? Math.min(Math.max((value / valorMax) * 100, 0), 100) : 0
        const corPonteiro = this.getCorFaixa(pct, params)
        return this.buildGaugeOption(pct, 0, 100, corPonteiro, params)
    }

    getOptionAbsoluto = (value, params) => {
        const valorMin = this.deriveMin(params)
        const valorMax = this.deriveMax(params, parseFloat(params?.valor_maximo) || 100)
        const corPonteiro = this.getCorFaixa(value, params)
        return this.buildGaugeOption(value, valorMin, valorMax, corPonteiro, params)
    }

    render() {
        const { params, value, unidade } = this.state.params
        const modoPercentual = params?.tipo_gauge === 'percentual'

        const numValue = parseFloat(value)
        const valorMax = parseFloat(params?.valor_maximo) || 100

        let displayValue = '—'
        let pctValue = 0
        if (!isNaN(numValue)) {
            if (modoPercentual) {
                pctValue = valorMax > 0 ? (numValue / valorMax) * 100 : 0
                displayValue = `${pctValue.toFixed(1)}%`
            } else {
                displayValue = numValue.toFixed(2)
            }
        }

        const corTexto = isNaN(numValue)
            ? '#262626'
            : this.getCorTexto(modoPercentual ? pctValue : numValue, params)

        const option = modoPercentual
            ? this.getOptionPercentual(numValue, params)
            : this.getOptionAbsoluto(numValue, params)
        const CLASSE_FAIXA = {
            valor_normal: 'bar-label-green',
            valor_alerta: 'bar-label-yellow',
            valor_perigo: 'bar-label-red',
        }

        const faixasLegenda = this.getFaixasNormalizadas(params)

        return (
            <div
                className="hdv-bloco-informacao hdv-chart-bloco-reactgridlayout"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: '100%',
                }}
            >
                {this.props.dataWidget?.ultimoEvento()}

                <div
                    style={{
                        position: 'relative',
                        width: '100%',
                        flex: '1 1 auto',
                        minHeight: 0,
                    }}
                >
                    <ReactECharts
                        option={option}
                        style={{ width: '100%', height: '100%' }}
                        opts={{ renderer: 'svg' }}
                        notMerge
                    />

                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: '8%',
                            pointerEvents: 'none',
                        }}
                    >
                        <span
                            style={{
                                display: 'flex',
                                alignItems: 'baseline',
                                gap: '4px',
                            }}
                        >
                            <strong
                                style={{
                                    fontSize: '1.6rem',
                                    fontWeight: 700,
                                    color: corTexto,
                                }}
                            >
                                {displayValue}
                            </strong>

                            {!modoPercentual && unidade && (
                                <span
                                    style={{
                                        fontSize: '0.95rem',
                                        fontWeight: 600,
                                        color: corTexto,
                                    }}
                                >
                                    {unidade}
                                </span>
                            )}
                        </span>
                    </div>
                </div>

                {faixasLegenda.length > 0 && (
                    <div className="bar-info">
                        {faixasLegenda.map((f) => (
                            <div
                                key={f.key}
                                className={`layout-inlineflex bar-label ${CLASSE_FAIXA[f.key]}`}
                            >
                                {f.min} até {f.max}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        )
    }
}

export default GraficoGauge